const backend_url = "https://webon.info/api/";

export const getData = (endpoint) => {
    return new Promise(async (resolve, reject) => {
        try {
            const res = await (await fetch(backend_url + endpoint)).json();
            resolve(res);
        } catch (e) {
            reject(e);
        }
    });
};
